import { Component } from '@angular/core';

@Component({
  selector: 'app-shriniwas-machine-craft-pvt-ltd',
  templateUrl: './shriniwas-machine-craft-pvt-ltd.component.html',
  styleUrls: ['./shriniwas-machine-craft-pvt-ltd.component.scss']
})
export class ShriniwasMachineCraftPvtLtdComponent {

}
